import { useEffect, useState } from "react";
import { fetchTop, type TopOpportunity } from "./api";
import { renderFlag } from "./copy";

// Slide-in panel: Top N real-scored unincorporated parcels.
// This is the PRODUCT (per Adam msg #428). The map is the demo.

export function RankedList({ open, onClose, onPick }: { open: boolean; onClose: () => void; onPick: (folio: string) => void }) {
  const [items, setItems] = useState<TopOpportunity[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    fetchTop(50).then(setItems).catch((e) => setErr(String(e)));
  }, [open]);

  if (!open) return null;

  return (
    <div className="ps-ranked" role="dialog" aria-label="Top opportunities">
      <header className="ps-ranked__head">
        <h2 className="ps-ranked__title">Top opportunities</h2>
        <span className="ps-ranked__sub">ranked by upzone potential · unincorporated MD only</span>
        <button className="ps-ranked__close" onClick={onClose} aria-label="Close">×</button>
      </header>

      {err && <p className="ps-ranked__err">API error: {err}</p>}
      {!items && !err && <p className="ps-ranked__loading">Loading…</p>}

      {items && items.length === 0 && (
        <p className="ps-ranked__empty">No real-scored parcels in current dataset.</p>
      )}

      {items && items.length > 0 && (
        <ol className="ps-ranked__list">
          {items.map((it) => {
            const flag = renderFlag({
              asOf: it.parcel.asOfDate,
              rulesetVersion: it.parcel.rulesetVersion,
              intent: it.parcel.liveLocalFlag ? "flag" : "signal",
            });
            return (
              <li key={it.parcel.folio} className="ps-ranked__row" onClick={() => onPick(it.parcel.folio)}>
                <span className="ps-ranked__rank">#{it.rank}</span>
                <span className="ps-ranked__score" style={{ background: scoreBg(it.parcel.opportunityScore ?? 0) }}>
                  {Math.round(it.parcel.opportunityScore ?? 0)}
                </span>
                <span className="ps-ranked__folio">{it.parcel.folio}</span>
                <span className="ps-ranked__phrase">{flag.phrase}</span>
                <span className="ps-ranked__stale">{flag.staleness}</span>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}

function scoreBg(s: number): string {
  if (s >= 80) return "#ed1f1f";
  if (s >= 60) return "#ed8a2e";
  if (s >= 40) return "#e3c83a";
  if (s >= 20) return "#3aa66f";
  return "#3a6fb8";
}
